import React, { useState } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import styled from 'styled-components';
import { Menu, MenuItem } from '@material-ui/core';
import { publishArticle } from '../../redux/api/blog';
import Snack from '../../shared/common/Snack';
import MessageModal from './MessageModal';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import ScheduleRoundedIcon from '@mui/icons-material/ScheduleRounded';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded';
import MoreVertRoundedIcon from '@mui/icons-material/MoreVertRounded';
// import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
// import { useEffect } from 'react';
// import DeleteConfirm from './DeleteConfirm';

const ArticleCard = props => {
    const { value, artId /* aDeletedArticle */ } = props;
    let history = useHistory();

    //STATES
    // const [articleToDelete, setArticleToDelete] = useState(null);
    // const [messageDeleteOpen, setMessageDeleteOpen] = useState(false);
    // const [contentDeleteMessage, setContentDeleteMessage] = useState(null);
    // const [deletedArticle, setDeletedArticle] = useState(null);
    const [publishedState, setPublishedState] = useState(value?.published);
    const [messageOpen, setMessageOpen] = useState(false);
    const [contentMessage, setContentMessage] = useState(null);
    const [errorOpen, setErrorOpen] = useState(false);

    //menu izq desplegable
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };
    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    //EFECTS
    // useEffect(() => {
    //     if (!!articleToDelete) {
    //         setMessageDeleteOpen(true);
    //         setContentDeleteMessage({
    //             message: '¿Confirmas que deseas eliminar el artículo seleccionado?!',
    //         });
    //     }
    // }, [articleToDelete]);

    // useEffect(() => {
    //     if (!!deletedArticle) {
    //         setMessageOpen(true);
    //         setContentMessage({
    //             message: '¡Artículo eliminado!',
    //             image: '/images/undraw_article.svg',
    //             subtitle: 'El artículo fue eliminado con éxito',
    //         });
    //         aDeletedArticle()
    //     }
    // }, [deletedArticle]);

    // FUNCTIONS
    function handleCloseError() {
        setErrorOpen(false);
    }

    const handlePublishState = async () => {
        //estado publicado: accion "Despublicar"
        if (!!publishedState) {
            let response = await publishArticle(artId, { publish: false });
            if (response.error) {
                setErrorOpen(true);
                <Snack open={errorOpen} handleClose={handleCloseError} severity="warning" color="#f44336">
                    El artículo no pudo despublicarse, favor de contactarse con el administrador.
                </Snack>;
            } else {
                setPublishedState(false);
                setMessageOpen(true);
                setContentMessage({
                    message: '¡Artículo despublicado!',
                    image: '/images/published_article.svg',
                    subtitle: 'El artículo fue despublicado con éxito',
                });
            }
        } else {
            //estado despublicado: accion "Publicar"
            let response = await publishArticle(artId, { publish: true });
            if (response.error) {
                setErrorOpen(true);
                <Snack open={errorOpen} handleClose={handleCloseError} severity="warning" color="#f44336">
                    El artículo no pudo publicarse, favor de contactarse con el administrador.
                </Snack>;
            } else {
                setPublishedState(true);
                setMessageOpen(true);
                setContentMessage({
                    message: '¡Artículo publicado!',
                    image: '/images/published_article.svg',
                    subtitle: 'El artículo fue publicado con éxito',
                });
            }
        }
    };

    // confirmar eliminacion
    // const handleDelete = async () => {
    //     let response = await deleteArticle( artId);
    //     if (response.error) {
    //         setErrorOpen(true);
    //         <Snack open={errorOpen} handleClose={handleCloseError} severity="warning" color="#f44336">
    //             El artículo no pudo eliminarse, favor de contactarse con el administrador.
    //         </Snack>;
    //     } else {
    //         setDeletedArticle(response);
    //         setMessageDeleteOpen(false);
    //         aDeletedArticle()
    //     }
    // };

    //cierre del modal de mensaje o click en boton Entendido
    const handleClose = () => {
        setMessageOpen(false);
        setContentMessage(null);
        // setArticleToDelete(null)
        // setMessageDeleteOpen(false)
        // setContentDeleteMessage(null)
    };

    const toDay = new Date().getTime();
    const updatedDay = new Date(value?.updatedAt).getTime();
    const publishedDay = value?.publication_date ? new Date(value?.publication_date).getTime() : null;
    const dateDiff = publishedDay ? (toDay - publishedDay) / (1000 * 60 * 60 * 24) : (toDay - updatedDay) / (1000 * 60 * 60 * 24);
    const dateDiffRounded = Math.round(dateDiff);

    //edición de curso
    const handleEditCourse = () => {
        history.push(`/edit-article/${artId}`);
    };

    //previsualizacion de curso
    const handleViewCourse = () => {
        history.push(`/articulo/${artId}`);
    };

    return (
        <>
            <Container>
                <CardFake>
                    <ButtonState bgc={publishedState}>
                        <CheckRoundedIcon />
                        {publishedState === true ? 'Publicado' : 'Borrador'}
                    </ButtonState>
                    <Header image={value?.cover?.data?.attributes?.url ? `${process.env.REACT_APP_CMS}${value?.cover?.data?.attributes?.url}` : ``} />

                    <Body>
                        <h2>{value?.title}</h2>
                        <Span>
                            <ScheduleRoundedIcon />
                            {dateDiffRounded === 0 ? 'Actualizado hoy' : `Hace ${dateDiffRounded} días`}
                        </Span>
                    </Body>

                    <Footer>
                        <>
                            <MoreVertRoundedIcon
                                id="basic-button"
                                aria-controls={open ? 'basic-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={open ? 'true' : undefined}
                                onClick={handleClick}
                            />
                            <MenuFake
                                id="basic-menu"
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleCloseMenu}
                                MenuListProps={{ 'aria-labelledby': 'basic-button' }}>
                                <MenuItem onClick={handleEditCourse}>
                                    <EditRoundedIcon />
                                    Editar
                                </MenuItem>
                                <MenuItem onClick={handleViewCourse}>
                                    <VisibilityRoundedIcon />
                                    Vista previa
                                </MenuItem>
                            </MenuFake>
                        </>
                        <ButtonToPublish bgc={publishedState} onClick={handlePublishState}>
                            {!!publishedState ? 'Despublicar' : 'Publicar'}
                        </ButtonToPublish>
                    </Footer>
                </CardFake>
            </Container>
            {/* confirmar artículo publicado/despublicado/eliminado */}
            <MessageModal
                isOpen={messageOpen}
                handleClose={handleClose}
                message={contentMessage?.message}
                image={contentMessage?.image}
                subtitle={contentMessage?.subtitle}
            />
            {/* solicitar confirmación previo a eliminar artículo */}
            {/* <DeleteConfirm
                isOpen={messageDeleteOpen}
                handleClose={handleClose}
                handleDelete={handleDelete}
                message={contentDeleteMessage?.message}
            /> */}
        </>
    );
};

export default ArticleCard;

const Container = styled.div`
    /* position: relative; */
`;

const CardFake = styled.div`
    /* min-width: 350px; */
    height: 375px;
    padding: 0;
    /* cursor: pointer; */
    width: 340px;
    border-radius: 20px;
    border: 1px solid #f1f1f1;
    box-shadow: 0px 4px 6px -4px rgba(24, 39, 75, 0.12), 0px 8px 8px -4px rgba(24, 39, 75, 0.08);
    position: relative;
`;

const Header = styled.div`
    height: 100px;
    padding: 1.5rem;
    border-radius: 20px;
    width: calc(100% - 3rem);
    background-image: url(${p => `${p.image}`});
    background-size: cover;
    background-position: center center;
`;

const Body = styled.div`
    padding: 1rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 0.8rem;
    h2 {
        color: #222222;
        font-size: 1.2rem;
    }
`;

const Span = styled.span`
    font-weight: 400;
    font-size: 0.9rem;
    line-height: 140%;
    color: #616161;

    svg {
        font-weight: 400;
        font-size: 0.9rem;
        line-height: 140%;
        color: #616161;
        padding-right: 1rem;
    }
`;

const ButtonState = styled.div`
    background-color: ${p => (!!p.bgc ? '#35D0A5' : '#616161')};
    border-radius: 5px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: max-content;
    padding: 0.3rem 0.5rem;
    gap: 0.25rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 0.75rem;
    line-height: 1rem;
    color: #ffffff;

    position: absolute;
    top: 2.5%;
    right: 2.5%;
`;

const ButtonToPublish = styled.div`
    background-color: ${p => (p.bgc === true ? 'var(--tertiary-three)' : 'var(--primary-one)')};
    border-radius: 48px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: max-content;
    padding: 0.5rem 1.5rem;
    gap: 0.5rem;
    font-weight: 600;
    font-size: 0.8rem;
    line-height: 1.5rem;
    letter-spacing: 0.001em;
    color: ${p => (p.bgc === true ? 'var(--secondary-three)' : '#FFFFFF')};
`;

const Footer = styled.div`
    display: flex;
    flex-direction: row;
    width: calc(100%-4rem);
    justify-content: space-between;
    align-items: center;
    padding: 1rem 2rem;
    height: calc(100%-2rem);
    gap: 0.8rem;
    position: absolute;
    bottom: 1%;
    left: 1%;
    right: 1%;
    background-color: #fafafa;

    svg {
        fill: var(--secondary-four);
        cursor: pointer;
    }
`;

const MenuFake = styled(Menu)`
    ul li span {
        color: var(--secondary-four);
        font-size: 0.8rem;
        font-weight: 400;
        font-family: 'Montserrat';
        font-style: normal;
    }

    .MuiList-root-MuiMenu-list {
        color: var(--secondary-four);
    }

    .MuiSvgIcon-root {
        fill: var(--secondary-four);
        margin-right: 1rem;
    }
    .MuiIconButton-colorPrimary:hover {
        background-color: transparent;
    }

    .MuiIconButton-root:hover {
        background-color: transparent;
    }

    .MuiButtonBase-root {
        width: 100%;
        justify-content: flex-start;
        color: #222222;
        font-size: 0.8rem;
        line-height: 1.5rem;
        font-weight: 500;
        font-family: 'Montserrat';
        font-style: normal;
    }
`;
